<template>
  <div class="page_container content-box">
    <AiBroadcastForm

    />
    <!-- Add AI broadcast -->
  </div>
</template>

<script>
import AiBroadcastForm from "./AiBroadcastForm.vue"

export default {
    components:{
        AiBroadcastForm,
    },
    data(){
        return{}
    },
}
</script>

<style>

</style>